<template>
  <b-container fluid>
    <b-row v-if="userForm['guid']" class="my-1">
      <b-col sm="3">
        <label class="inline" for="userGuid">
          <strong>GUID:</strong>
        </label>
      </b-col>
      <b-col sm="9">
        <b-input-group class="mb-4">
          <b-input id="userGuid" v-model="userForm['guid']" readonly></b-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row v-if="userForm['exostarExostarID']" class="my-1">
      <b-col sm="3">
        <label class="inline" for="exostarId">
          <strong>Exostar ID:</strong>
        </label>
      </b-col>
      <b-col sm="9">
        <b-input-group class="mb-4">
          <b-input id="exostarId" v-model="userForm['exostarExostarID']" readonly></b-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col sm="3">
        <label for="userRole"><strong>Role</strong>:</label>
      </b-col>
      <b-col sm="9">
        <b-select
          id="userRole"
          v-model="userForm['simRole']"
          :options="rolesOptions"
          class="mb-4"
          @input="onUpdate"
        ></b-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col sm="3">
        <label for="userPermissions"><strong>Permissions</strong>:</label>
      </b-col>
      <b-col sm="9">
        <b-form-checkbox-group
          v-if="salesforceMap.length > 0"
          id="userPermissions"
          v-model="userForm['simPermission']"
          class="mb-4"
          stacked
          switches
        >
          <b-form-checkbox
            v-for="permission in permissionOptions"
            :key="permission.value"
            :disabled="isDisabled(permission.name)"
            :value="permission.name"
            @input="onUpdate"
          >
            {{ permission.name }}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <b-spinner v-else label="Loading permissions" small variant="primary"></b-spinner>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import { mapMutations } from 'vuex';

  export default {
    name: 'edit-user-form',
    data() {
      return {
        salesforceMap: [],
        rolesOptions: ['User', 'Pfizer User', 'Exostar User', 'Admin'],
        permissionOptions: [
          { name: 'Surveys', value: 'access surveys' },
          { name: 'My Enrollments', value: 'access my enrollments' },
          { name: 'Enrollment Oversight', value: 'access enrollment oversight' },
          { name: 'Application Access', value: 'access application access' },
          { name: 'Application Access Manager', value: 'access application access manager' },
          { name: 'Start-Up Plan', value: 'access start-up plan' },
          { name: 'Milestones', value: 'access milestones' },
          { name: 'System Outage', value: 'access system outage messages' },
          { name: 'Forms', value: 'access forms' },
          { name: 'Admin', value: 'access admin area' },
        ],
      };
    },
    computed: {
      userForm: {
        get() {
          return this.$store.state.salesforceUserForm.userForm;
        },
        set(form) {
          this.$store.commit('salesforceUserForm.updateForm', form);
        },
      },
    },
    watch: {
      'userForm.simRole'(newRole) {
        let selectedRole = this.salesforceMap.find(({ role }) => role === newRole);
        this.userForm['simPermission'] = selectedRole.permissions;
      },
    },
    created() {
      this.userForm['simPermission'] =
        this.userForm['simPermission'] !== null ? this.userForm['simPermission'] : [];
      this.getDefaultPermissions();
    },
    methods: {
      ...mapMutations({
        setForm: 'updateUserForm',
      }),
      getDefaultPermissions() {
        axios.get('/api/role-default-permission').then(results => {
          this.salesforceMap = results.data.items;
        });
      },
      onUpdate() {
        this.setForm(this.userForm);
      },
      isDisabled(value) {
        if (this.salesforceMap.length > 0 && value && this.userForm['simRole']) {
          let selectedRole = this.salesforceMap.find(
            ({ role }) => role === this.userForm['simRole'],
          );
          return selectedRole.permissions.includes(value);
        }
      },
    },
  };
</script>
